import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleProduct from "./sections/SingleProduct"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <SingleProduct />
    </div>
  )
}
